import { render } from "./home-testimonials.vue?vue&type=template&id=3bad33cf"
import script from "./home-testimonials.vue?vue&type=script&lang=js"
export * from "./home-testimonials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__